import { PAYROLL, LOGIN } from '@core/router/app-states';
import { EnvironmentConfigType } from './environment-config-type';
import { COMMON_CONFIG } from './common-config';
import { BACKEND_URLS } from 'src/config/backends';

export const environment: EnvironmentConfigType = {
  production: true,
  testingEnabled: false,
  flavour: 'default',
  settings: {
    url: 'https://app.salarispayroll.com/',
    defaultLocale: 'en-US',
    grid: {
      numberOfSlotsPerDay: 96
    },
    plans: {
      ...COMMON_CONFIG.settings.plans
    },
    home_dev_support: PAYROLL,
    home_employer: PAYROLL,
    setup_employer: PAYROLL,
    logged_in_refresh_interval: 10 * 60 * 1000,
    listPerPage: 20,
    endpoint_root: '.salarispayroll.com',
    freeCloudStorageMaxDayRange: 28,
    localStoragePrefix: 'pay_local_storage'
  },
  value: 'production',
  oauth: {
    clientId: 'zfwsdNZGSB3pkZw8l5b2QRQZ12HtWMgI4G2C0u32',
    clientSecret: 'AweqBOIZVbheDve6bRhrrfEYyrdfh8YMB7JL5v4z'
  },
  google: {
    key: 'AIzaSyDWuiQnrl_NUYn0XXlUgTfKqsa9sXp9Et4',
    mapId: 'e0588c2bb6ea34c3'
  },
  api: {
    endpointBase: `${ BACKEND_URLS['PROD'] }`,
    endpoint: `${ BACKEND_URLS['PROD'] }${ '/v3' }`,
    endpointV2:`${ BACKEND_URLS['PROD'] }${ '/v2' }`,
    endpointAuth:`${ BACKEND_URLS['PROD'] }${ '/auth' }`,
    refer: 'https://oss.ws/r',
    util: 'https://oss.ws',
  },
  default: {
    support: 'https://www.salarispayroll.com/for-customers',
  },
  paths: {
    login: {
      url: `/${ LOGIN }`,
    },
    restricted: {
      url: '/error/restricted',
    },
    home: {
      employerIHD: {
          url: `/${ PAYROLL }`,
          state: PAYROLL,
      },
      employer: {
        url: `/${ PAYROLL }`,
        state: PAYROLL,
      },
    },
  },
  logger: {
    environment: {
        production: false,
        others: true,
    },
  },
  routes: {
    ...COMMON_CONFIG.routes,
  },
  intercom: {
    app_id: 'lc8j2j2n',
  },
  assets: {
    feedbackUrl:
        'https://salaris-payroll.canny.io/feature-requests',
    localeUrl:
        'https://resources.salarispayroll.com/locales/:locale/generic.json', // en-US
  }
};
